(() => {
  if (customElements.get('voler-feature-tour')) return;
  customElements.define('voler-feature-tour', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const panels = [...this.querySelectorAll('[data-panel]')];
      const spots = [...this.querySelectorAll('[data-feature]')];
      const views = [...this.querySelectorAll('[data-garment]')];
      const rail = this.querySelector('[data-view-rail]');
      const keys = spots.map(spot => spot.dataset.feature);
      const viewFor = key => spots.find(spot => spot.dataset.feature === key)?.closest('[data-garment]')?.dataset.garment;
      if (!keys.length || new Set(keys).size !== keys.length || keys.some(key => panels.filter(p => p.dataset.panel === key).length !== 1) || panels.length !== spots.length || views.length !== 2 || views.some(view => !spots.some(spot => spot.closest('[data-garment]') === view))) return;
      this.controller = new AbortController();
      if (!this.classList.contains('catalog-feature-tour--all-mountain')) this.connectDetailLine();
      this.querySelectorAll('img').forEach(img => {
        img.addEventListener('error', () => { this.hidden = true; }, {signal:this.controller.signal});
        if (img.complete && !img.naturalWidth) this.hidden = true;
      });
      const remembered = Object.fromEntries(views.map(view => [view.dataset.garment, spots.find(spot => spot.closest('[data-garment]') === view).dataset.feature]));
      const select = (key, announce = true) => {
        if (!keys.includes(key)) return;
        const view = viewFor(key);
        remembered[view] = key;
        panels.forEach(p => p.hidden = p.dataset.panel !== key);
        spots.forEach(p => p.setAttribute('aria-pressed', String(p.dataset.feature === key)));
        this.querySelectorAll('[data-view]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.view === view)));
        if (announce) this.querySelector('[data-announcement]').textContent = panels.find(p => p.dataset.panel === key).innerText;
        this.drawDetailLine?.();
      };
      const showView = (view, announce = true) => {
        if (!remembered[view]) return;
        select(remembered[view], announce);
        const target = views.find(node => node.dataset.garment === view);
        if (window.innerWidth < 700 && rail && target) rail.scrollTo({left:target.offsetLeft,behavior:'smooth'});
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.dataset.feature) select(button.dataset.feature);
        if (button.dataset.view) showView(button.dataset.view);
      }, {signal:this.controller.signal});
      rail?.addEventListener('focusin', event => {
        const spot = event.target.closest('[data-feature]');
        if (spot && rail.contains(spot)) select(spot.dataset.feature);
      }, {signal:this.controller.signal});
      rail?.addEventListener('scroll', () => {
        if (window.innerWidth >= 700 || this.scrollFrame) return;
        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = null;
          const nearest = views.reduce((best, view) => Math.abs(view.offsetLeft - rail.scrollLeft) < Math.abs(best.offsetLeft - rail.scrollLeft) ? view : best, views[0]);
          select(remembered[nearest.dataset.garment], false);
        });
      }, {passive:true,signal:this.controller.signal});
      this.querySelectorAll('.vft__pagination,.vft__hotspot,.vft__hint').forEach(p => p.hidden = false);
      this.dataset.enhanced = '';
      select(keys[0], false);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.connectorObserver?.disconnect();
      if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
      this.connector?.remove();
      this.connector = null;
      this.drawDetailLine = null;
      this.controller = null;
    }
    connectDetailLine() {
      const layout = this.querySelector('.vft__layout');
      if (!layout?.getBoundingClientRect || typeof ResizeObserver === 'undefined') return;
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      svg.classList.add('vft__connector');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('hidden', '');
      svg.append(line);
      layout.append(svg);
      this.connector = svg;
      this.drawDetailLine = () => {
        const spot = this.querySelector('[data-garment] [data-feature][aria-pressed="true"] span');
        const panel = this.querySelector('[data-panel]:not([hidden])');
        const title = panel?.querySelector('h3');
        const visible = window.innerWidth >= 1000 && !this.hidden && spot && title;
        svg.toggleAttribute('hidden', !visible);
        if (!visible) { line.removeAttribute('d'); return; }
        const r = layout.getBoundingClientRect(), b = spot.getBoundingClientRect(), p = panel.getBoundingClientRect(), t = title.getBoundingClientRect();
        const x = b.right - r.left + 6, y = b.top + b.height / 2 - r.top;
        const endX = p.left - r.left, endY = t.top + t.height / 2 - r.top;
        if (endX <= x || !r.width || !r.height) { svg.setAttribute('hidden', ''); line.removeAttribute('d'); return; }
        svg.setAttribute('viewBox', `0 0 ${r.width} ${r.height}`);
        line.setAttribute('d', `M ${x} ${y} L ${endX} ${endY}`);
      };
      this.connectorObserver = new ResizeObserver(() => this.drawDetailLine?.());
      this.connectorObserver.observe(layout);
      window.addEventListener('resize', () => this.drawDetailLine?.(), {signal:this.controller.signal});
      this.addEventListener('load', () => this.drawDetailLine?.(), {capture:true,signal:this.controller.signal});
    }
  });
})();
